import { createStore } from "vuex";
import router from "../router";
import axios from "axios";
import chat from "./chat";
const store = createStore({
  state: {
    name: "Vue",
    UKEY: "<VEINS2021/>",
    userRoles: [],
    ProfileImage: "",
    localStorage: null,
    cando: null,
    xeon: null,
    headerDisplay: true,
    sidebarDisplay: true,
    AuthToken: "",
    AuthTokenOnly: "",
    filterSTGDSP: {
      externalid: "",
      veinsId: "",
      firstname: "",
      lastname: "",
      phone: "",
      Dob: "",
      sdate: "",
      Status: "",
      startDate: "",
      endDate: "",
      refreshData: false,
    },
  },
  getters: {
    getheaderDisplay(state) {
      const item = state.headerDisplay;
      return item;
    },
    getsidebarDisplay(state) {
      return state.sidebarDisplay;
    },
    getProfileImage(state) {
      return state.ProfileImage;
    },
    geterLocalStorage(state) {
      return state.localStorage;
    },
    getLocalStoragecando(state) {
      return state.cando;
    },
    getLocalStoragexeon(state) {
      return state.xeon;
    },
    getAuthToken(state) {
      return state.AuthToken;
    },
    getAuthTokenOnly(state) {
      return state.AuthTokenOnly;
    },
  },
  mutations: {
    //setter
    async setAuthToken(state, payload) {
      state.AuthToken = "Bearer " + payload;
    },
    setAuthTokenOnly(state, payload) {
      state.AuthTokenOnly = payload;
    },
    setHeaderDisplay(state, val) {
      state.headerDisplay = val;
    },
    setsidebarDisplay(state, val) {
      state.sidebarDisplay = val;
    },
    setUserDate(state, val) {
      state.ProfileImage = val;
    },
    setlocalStorage(state, payload) {
      state.localStorage = payload;
    },
    setlocalStorageCando(state, payload) {
      //debugger;
      state.cando = payload;
    },
    setlocalStorageXeon(state, payload) {
      //debugger;
      state.xeon = payload;
    },
    setFilterSTGDSP_MUT(state, payload) {
      const obj = JSON.stringify(payload);
      state.filterSTGDSP = JSON.parse(obj);
      return null;
    },
  },
  actions: {
    setFilterSTGDSP_ACT({ commit }, payload) {
      commit("setFilterSTGDSP_MUT", payload);
    },
    setlocalStorage(state, payload) {
      state.localStorage = payload;
    },
    setlocalStorageCando(state, payload) {
      state.cando = payload;
    },
    setlocalStorageXeon(state, payload) {
      state.xeon = payload;
    },
    setHeaderDisplayA({ commit }, payload) {
      commit("headerDisplay", payload);
      return null;
    },
    setSidebarDisplayA({ commit }, payload) {
      commit("sidebarDisplay", payload);
      return null;
    },
    setImage({ commit }, payload) {
      commit("setUserDate", payload);
      return null;
    },
    setUserKey({ commit }, payload) {
      commit("setUserUKey", payload);
      return null;
    },
    setNewlocalStorage(context, payload) {
      context.commit("setlocalStorage", payload);
    },
    setNewlocalStorageCando(context, payload) {
      context.commit("setlocalStorageCando", payload);
      return null;
      //router.push({ path: '/StageDisplay' });// should not be here
    },
    setAuthTokenAction(context, payload) {
      context.commit("setAuthToken", payload);
      //router.push({ path: '/StageDisplay' });
      return null;
    },
    setNewlocalStorageXeon(context, payload) {
      //debugger;
      context.commit("setlocalStorageXeon", payload);
    },
    async GetBearerToken(context, payload, str) {
      const Url =
        this.SERVER + "/VNSPRAAPI/Accounts/AuthenticateToken?token=" + str;
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          const myData = res.data;
          if (myData.status == true) {
            context.commit("setAuthToken", myData.token);
            context.commit("setAuthTokenOnly", myData.token);
            localStorage.BeToken = myData.token;
            console.log(this.$store.getters.getAuthTokenOnly);
            return true;
          } else {
            if (myData.error == true) {
              return false;
            }
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {});
    },
  },
  modules: {
    chat,
  },
});

export default store;
